import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function Section1() {
  const navigate = useNavigate();
   const eventData = useSelector((state) => state.event.eventData);
   const event = eventData.events;
   const bakgroundImage = eventData.events.imageKey;
   const subevent = eventData.events.awards;
   console.log("subevent",subevent)
   
  return (
    <div>
     
   

    <section
        className="position-relative overflow-hidden space"
        id="destination-sec"
        style={{
          backgroundImage: `url(${bakgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-6">
              <div className="title-area">
                <span className="sub-title">{event.title}</span>
                <h2 className="sec-title">{event.subTitle}</h2>
              </div>
            </div>
            <div className="col-lg-5">
             
              <p className="sec-text mb-30">
               {event.description}
              </p>
            </div>
          </div>

          <div className="slider-area">
            <Swiper
              className="th-slider has-shadow"
              modules={[Navigation, Pagination]}
              spaceBetween={30}
              loop={true}
              navigation
              pagination={{ clickable: true }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 2 },
                1200: { slidesPerView: 3 },
                1300: { slidesPerView: 4 },
              }}
            >
              {
              subevent.map((item, idx) => (
                <SwiperSlide key={idx}>
                  <div className="destination-item th-ani">
                    <div className="destination-item_img global-img">
                      <img
                        src={item.imageKey}
                        alt={item.title}
                      />
                    </div>
                    <div className="destination-content">
                      <h3 className="box-title">
                        <a href="destination-details.html">{item.name}</a>
                      </h3>
                      <p className="destination-text">{item.date}</p>
                      <div className="destination-btn text-center mt-60" style={{cursor:"pointer"}}>
                      <a onClick={() => navigate('/event/details', { state: { item } })}>View</a>


          </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="destination-btn text-center mt-60">
            <a href="/event" className="th-btn style3 th-icon">
              View All
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Section1;
